import { Response } from '../../../../../_metronic/helpers'

/**
 * A quem o termo se destina. `Paciente` é o TCLE aceito por atendimento; `Usuario` é o termo de
 * ciência (LGPD) que todo usuário da plataforma registra no primeiro acesso e a cada versão nova.
 * Vale um termo publicado por tipo.
 */
export enum TipoTermoConsentimento {
  Paciente = 'PACIENTE',
  Usuario = 'USUARIO',
}

export const TIPO_TERMO_LABELS: Record<TipoTermoConsentimento, string> = {
  [TipoTermoConsentimento.Paciente]: 'Paciente (TCLE por atendimento)',
  [TipoTermoConsentimento.Usuario]: 'Usuário da plataforma (ciência no primeiro acesso)',
}

export interface TermoConsentimento {
  id?: number
  versao: string
  titulo: string
  conteudo: string
  hash?: string
  dtVigenciaInicio?: string
  dtVigenciaFim?: string
  publicado?: boolean
  createdAt?: string
  /** Ausente = `Paciente`, que é o que o backend assume. */
  tipo?: TipoTermoConsentimento
}

export type TermosQueryResponse = Response<Array<TermoConsentimento>>

/**
 * `code` do 403 que o backend devolve em qualquer rota enquanto o usuário logado não registra ciência do
 * termo vigente (`TermoCienciaRequiredFilter`).
 */
export const TERMO_CIENCIA_PENDENTE_CODE = 'TERMO_CIENCIA_PENDENTE'

export const ehTermoCienciaPendente = (error: unknown): boolean => {
  const response = (error as { response?: { status?: number; data?: { code?: string } } })?.response
  return response?.status === 403 && response.data?.code === TERMO_CIENCIA_PENDENTE_CODE
}

/** `POST /termos/usuario/aceite` */
export type AceiteTermoUsuarioDto = {
  idTermo: number
}

export type AceiteTermoUsuario = {
  id: number
  dtAceite: string
}
